import React from "react";
import { Box, Typography } from "../../../design-system";
import { colors } from "../../../design-system/colors";
import { PAGE_TITLE } from "../constants/myLibraryText";

const MyLibraryPageHeader: React.FC = (): JSX.Element => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      marginBottom: "32px",
    }}
  >
    <Typography
      variant="headingDisplay"
      color="white"
      sx={{
        fontSize: "60px",
        fontWeight: 700,
        fontFamily: "Outfit, sans-serif",
        lineHeight: "1.2",
        color: colors.neutral.white,
      }}
    >
      {PAGE_TITLE}
    </Typography>
  </Box>
);

export default MyLibraryPageHeader;
